import React from 'react'

import styled from 'styled-components'
import tw from 'tailwind.macro'
import icon from '@/images/cajitas.svg'

const StHero = styled.div`
  ${tw` relative pt-16 text-center`}
  background-color: #f2f7fc;
  .bg {
    border: 1px solid cornflowerblue;
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    &:after {
      content: '';
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      background-image: linear-gradient(
        to right,
        rgba(242, 247, 252, 1),
        rgba(242, 247, 252, 1),
        rgba(242, 247, 252, 0)
      );
    }
  }
  .content {
    position: relative;
    z-index: 2;
  }
  .cajitas {
    position: relative;
    left: 2%;
  }
`

const Hero = () => {
  return (
    <StHero>
      <div className="content">
        <div className="mx-auto md:max-w-screen-sm sm:p-8 p-3">
          <div className="mt-16">
            <img className="cajitas" src={icon} />
            <h1 className="leading-none text-6xl my-4">¿Cómo votó mi mesa?</h1>
            <p className="text-xl leading-tight mt-0">
              Todos sabemos lo que marcamos en nuestro voto el pasado 25 de
              octubre pero, ¿Te has preguntado cuáles fueron los resultados en
              tu mesa, comuna y región? ¿Fue tu preferencia la más votada en
              esos lugares o eres una minoría? Te invitamos a averiguarlo.
            </p>
          </div>
        </div>
      </div>
    </StHero>
  )
}

export default Hero
